export reducer from './reducer';
export * as actions from './actions';
export {fetchSubject, fetchAlertSubject} from './tasks';



/** WEBPACK FOOTER **
 ** ./src/app/modules/subject/index.js
 **/